export function queueMacrotask(task) {
  setTimeout(task, 0);
}